export function userSpeakerLabel(isAuthenticated, user) {
  if (!isAuthenticated) return 'USER'
  const local = (user?.email || '').split('@')[0]
  return (local || 'USER').toUpperCase()
}

export function isEnglishVoice(voice) {
  return /^en(-|$)/i.test(voice?.lang || '') || /english/i.test(voice?.name || '')
}
